// extracted by mini-css-extract-plugin
export default {"rootContainer":"Style_rootContainer__aj9m5","menuList":"Style_menuList__eWEPV","open":"Style_open__ox-6Z","text":"Style_text__ZdP51","animating":"Style_animating__xBmSp"};